// Static color mapping for chart series
export const SERIES_COLOR_MAP: Record<string, string> = {
  Total: '#003771',
  Successful: '#01C008',
  Failed: '#D82B51',
  Aborted: '#F57600',
  'In Progress': '#FD9532',
  Delayed: '#FF38B0',
};

export  const includeGroupByMenuColumns:string[] = ['job_id','job_type','job_name','source_type','program_name', 'subscription_name', 'subscription_id', 'resource_group', 'market', 'gdo'];

// Chart configuration constants
export const ECHO_CHART_CONFIG = {
  legend: {
    bottom: 0,
    left: '0%',
    icon: 'rect',
    itemWidth: 14,
    itemHeight: 14,
    textStyle: { fontSize: 15, padding: [0, 0, 0, 4], fontFamily: 'Montserrat' },
  },
  grid: {
    left: '3%',
    right: '3%',
    top: '10%',
    bottom: '18%',
    containLabel: true,
  },
  tooltip: { trigger: 'axis' },
};

export const Y_AXIS_STATUS_CONFIG = {
  type: 'value',
  min: 0,
  max: 100,
  name: 'Status %',
  nameLocation: 'middle',
  nameGap: 50,
  nameTextStyle: {
    fontSize: 12,
    color: '#6B7280',
  },
  axisLabel: {
    formatter: '{value}%',
  },
};

export const getYAxisJobsConfig = (maxValue: number) => ({
  type: 'value',
  name: 'Total Jobs',
  nameLocation: 'middle',
  nameGap: 50,
  min: 0,
  max: maxValue,
  nameTextStyle: {
    fontSize: 12,
    color: '#6B7280',
  },
  axisLabel: {
    formatter: (value: number) => {
      if (value >= 1_000_000_000) {
        return (value / 1_000_000_000).toFixed(1) + 'B';
      }
      if (value >= 1_000_000) {
        return (value / 1_000_000).toFixed(1) + 'M';
      }
      if (value >= 1_000) {
        return (value / 1_000).toFixed(1) + 'k';
      }
      return value;
    },
  },
});

export const LINE_STYLE_CONFIG = {
  type: 'line',
  smooth: false,
  showSymbol: true,
  lineStyle: { width: 2 },
};